
<ng-container *ngIf="subjectData?.nodeName!=null">
    <div class="SLV2-resumlearn-card {{subjectData?.nodeName?.replace(' ','') | lowercase}}"  (click)="navigateToResumeLearning()">
        <div class="SLV2-resumlearn-icnholder">
            <img [src]="getSubjectIcon(subjectData?.nodeName?.replace(' ','') | lowercase)" />
        </div>
        <div class="SLV2-resumlearn-cntarea">
            <h6 class="SLV2-resumlearn-suptitle">Resume learning</h6>
            <h4 class="SLV2-resumlearn-title">{{isFromHomeScreen ? data.data.topicName : data.topicName}}</h4>
            <h5 class="SLV2-resumlearn-subtitle">{{ isFromHomeScreen ?  data.data.name : data.videoName}}</h5>
        </div>
    
        <button class="SLV2-resumlearn-btn"></button>
    </div>
</ng-container>